import {
  type SanitySortOption,
  type SanitySortOptionType,
} from '@data/sanity/queries/types/cart'
import { type SanityCollectionStrings } from '@data/sanity/queries/types/modules'
import { type UrlParameter } from '@lib/hooks'

import Label from '@components/label'
import CollectionListbox from './listbox'

interface CollectionSortProps {
  collectionStrings: SanityCollectionStrings
  sortOptions: SanitySortOption[]
  activeSortValue: SanitySortOptionType | null
  onChange: (newParameters: UrlParameter[]) => void
}

const CollectionSort = ({
  collectionStrings,
  sortOptions,
  activeSortValue,
  onChange,
}: CollectionSortProps) => (
  <div className="flex ml-auto px-2 sm:px-4">
    <CollectionListbox
      id="collection-sort"
      name="sort"
      label={collectionStrings.collectionSortDescription}
      options={sortOptions}
      activeOption={activeSortValue}
      onChange={onChange}
      before={
        <Label
          secondary
          hasDot
          pulsingDot
          className="hidden sm:inline font-semibold uppercase"
        >
          {collectionStrings.collectionSortLabel}:
        </Label>
      }
      className="flex"
    />
  </div>
)

export default CollectionSort
